import React from "react";
import "./ServicePage.css";
import lawyer from "../images/costume.jpg";
import lukasacademy from "../images/lukaacademy.png";
import driver from "../images/driver.jpg";
import image from "../images/image.jpg";
import translate from "../images/translate.jpg";

const ServicePage = ({ language }) => {
  const redirectUrl = {
    lawyer: "https://www.facebook.com/profile.php?id=100086438881286",
    lukaAcademy: "https://www.facebook.com/Espanuriena",
    visa: "https://www.facebook.com/groups/1776120319103304",
    driver: "https://www.facebook.com/groups/186174096763989",
    translate: "https://www.facebook.com/groups/266342438508375",
  };

  const handleClick = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div id="services">
      <h1 className="services-text">{language.services}</h1>
      <div className="services-container">
        <div
          onClick={() => handleClick(redirectUrl.lawyer)}
          className="service-info "
          style={{ backgroundImage: `${"url(" + lawyer + ")"}` }}
        >
          <h2>{language.lawyer}</h2>
        </div>
        <div
          onClick={() => handleClick(redirectUrl.lukaAcademy)}
          className="service-info"
          style={{ backgroundImage: `${"url(" + lukasacademy + ")"}` }}
        >
          <h2>{language.academy}</h2>
        </div>
        <div
          onClick={() => handleClick(redirectUrl.visa)}
          className="service-info"
          style={{ backgroundImage: `${"url(" + image + ")"}` }}
        >
          <h2>{language.visa}</h2>
        </div>
        <div
          onClick={() => handleClick(redirectUrl.driver)}
          className="service-info"
          style={{ backgroundImage: `${"url(" + driver + ")"}` }}
        >
          <h2>{language.driver}</h2>
        </div>
        <div
          onClick={() => handleClick(redirectUrl.translate)}
          className="service-info"
          style={{ backgroundImage: `${"url(" + translate + ")"}` }}
        >
          <h2>{language.translate}</h2>
        </div>
      </div>
    </div>
  );
};

export default ServicePage;
